'use client';
import { createContext } from '@chakra-ui/utils/context';
import { createDescendantContext } from '../descendant/use-descendant.mjs';

const [MenuProvider, useMenuContext] = createContext({
  strict: false,
  name: "MenuContext"
});
const [
  MenuDescendantsProvider,
  useMenuDescendantsContext,
  useMenuDescendants,
  useMenuDescendant
] = createDescendantContext();
const [MenuStylesProvider, useMenuStyles] = createContext({
  name: `MenuStylesContext`,
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
});

export { MenuDescendantsProvider, MenuProvider, MenuStylesProvider, useMenuContext, useMenuDescendant, useMenuDescendants, useMenuDescendantsContext, useMenuStyles };
